import React from "react";

/* A bin — the destructive action on a record card. */
export const TrashIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M4.5 7h15M9.5 7V5.4A1.4 1.4 0 0110.9 4h2.2a1.4 1.4 0 011.4 1.4V7"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M6.5 7l.8 11.3A1.8 1.8 0 009.1 20h5.8a1.8 1.8 0 001.8-1.7L17.5 7"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.4 10.8v5.4M13.6 10.8v5.4"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default TrashIcon;
